<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form action="login">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Login</h3>
              </div>
              <div>
                <fg-input label="Email address"
                          placeholder="Enter email"
                          type="email"
                          v-model="model.email"
                          @keyup.enter="login"
                          ref="tofocus">

                </fg-input>
                <fg-input label="password"
                          type="password"
                          placeholder="Password"
                          v-model="model.password"
                          @keyup.enter="login">
                </fg-input>
                <!-- <fg-input>
                  <l-checkbox v-model="model.subscribe">
                    Subscribe to newsletter
                  </l-checkbox>
                </fg-input> -->
              </div>
              <br>
              <div :style="{color: 'red', }" class="ml-auto"> {{serverResponse}} </div>
              <br>
              <div class="text-center">
                <button type="button" @click="login" class="btn btn-fill btn-info btn-round btn-wd ">Login</button>
                <br>
                <div class="forgot">
                  <a href="mailto:support.affiliate@incentifyhq.com?subject=Password Lost&body=Hi, I lost my password, can you help me?">
                    Lost your password?
                  </a>
                </div>
              </div>
            </card>
          </fade-render-transition>

        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
  import { Checkbox as LCheckbox, FadeRenderTransition } from 'src/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      LCheckbox,
      FadeRenderTransition,
      AuthLayout,
    },
    data () {
      return {
        model: {
          email: '',
          password: '',
          /* subscribe: true */
        },
        serverResponse: '',
      }
    },
    mounted () {
        this.$refs.tofocus.$el.children[1].focus()
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      async login () {
        try {
          // if (response && response.errors) {
          //   this.serverResponse = response.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue)
          // }
          var response = await this.$store.dispatch('login', {email: this.model.email, password: this.model.password})

          if (response && response.errors) {
            this.serverResponse = response.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue)
          }
        }
        catch (error) {
          console.log('login(): error:', error)
        }
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
